import { AuthTokenStorage, authTokenStorage } from '~/gateways/auth/authTokenStorage';
import { companyIdAttachingNetworkManager } from './companyIdAttachingNetworkManager';
import { MagicRequest } from './magicRequest';
import { NetworkManager } from './networkManager';

class AuthenticatingNetworkManager implements NetworkManager {
  private networkManager: NetworkManager;
  private authTokenStorage: AuthTokenStorage;

  constructor(tokenStorage: AuthTokenStorage, networkManager: NetworkManager) {
    this.networkManager = networkManager;
    this.authTokenStorage = tokenStorage;
  }

  public sendRequest = async (request: MagicRequest): Promise<Response> => {
    let newRequest = request;
    const token = this.authTokenStorage.getAuthToken();
    if (token) {
      const newHeaders: Headers = request.headers;
      newHeaders.append('Authorization', `Bearer ${token}`);
      newRequest = {
        ...request,
        headers: newHeaders,
      };
    }
    return await this.networkManager.sendRequest(newRequest);
  };
}

export const authenticatingNetworkManager = new AuthenticatingNetworkManager(authTokenStorage, companyIdAttachingNetworkManager);
